/**
 * ODSP article layout: build TOC from H2s, accordion, active link tracking.
 */
(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function uniqueId(base, used) {
    var id = base || 'section';
    var n = 1;
    var candidate = id;
    while (used[candidate] || document.getElementById(candidate)) {
      candidate = id + '-' + n;
      n += 1;
    }
    used[candidate] = true;
    return candidate;
  }

  function buildToc(root) {
    var body = root.querySelector('[data-odsp-article-body]');
    if (!body) return;

    var headings = body.querySelectorAll('h2');
    var desktopList = root.querySelector('[data-odsp-toc="desktop"]');
    var pillsList = root.querySelector('[data-odsp-toc="pills"]');
    var mobileList = root.querySelector('[data-odsp-toc="mobile"]');
    var used = {};

    if (!headings.length) {
      root.classList.add('odsp-article-layout--no-toc');
      return;
    }

    var items = [];
    headings.forEach(function (h2, index) {
      var text = (h2.textContent || '').trim();
      if (!text) return;
      if (!h2.id) {
        h2.id = uniqueId(slugify(text), used);
      } else {
        used[h2.id] = true;
      }
      items.push({ id: h2.id, text: text, index: index + 1 });
    });

    function fillList(listEl, asPills) {
      if (!listEl) return;
      listEl.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + item.id;
        a.textContent = asPills ? item.index + '. ' + item.text : item.index + '. ' + item.text;
        a.dataset.odspTocLink = item.id;
        li.appendChild(a);
        listEl.appendChild(li);
      });
    }

    fillList(desktopList, false);
    fillList(pillsList, true);
    fillList(mobileList, false);

    root.querySelectorAll('[data-odsp-toc-link], a[data-odsp-toc-link]').forEach(function () {});
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      if (!a.dataset.odspTocLink) return;
      a.addEventListener('click', function () {
        var accordion = root.querySelector('[data-odsp-toc-accordion]');
        if (accordion && accordion.classList.contains('is-open')) {
          accordion.classList.remove('is-open');
          var btn = accordion.querySelector('[data-odsp-toc-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    setupActiveTracking(root, items);
  }

  function setupActiveTracking(root, items) {
    if (!items.length || !('IntersectionObserver' in window)) return;

    var linkMap = {};
    root.querySelectorAll('a[data-odsp-toc-link]').forEach(function (a) {
      var id = a.dataset.odspTocLink;
      if (!linkMap[id]) linkMap[id] = [];
      linkMap[id].push(a);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          Object.keys(linkMap).forEach(function (key) {
            linkMap[key].forEach(function (a) {
              a.classList.toggle('is-active', key === id);
            });
          });
        });
      },
      { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
    );

    items.forEach(function (item) {
      var el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });
  }

  function setupAccordion(root) {
    var accordion = root.querySelector('[data-odsp-toc-accordion]');
    if (!accordion) return;
    var btn = accordion.querySelector('[data-odsp-toc-toggle]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var open = accordion.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('[data-odsp-article-layout]').forEach(function (root) {
      buildToc(root);
      setupAccordion(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-odsp-article-layout]');
    if (root) {
      buildToc(root);
      setupAccordion(root);
    }
  });
})();
